/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * `LearnArtifactSummary` without `visit_id`, for the anonymous take-home page only.
 * 
 * `TakeHomeView.visit` is `additionalProperties: false` with `id` deliberately omitted — that
 * page is not meant to carry the Visit UUID. Reusing the shared summary handed it back on
 * every item, so the omission described the object and not the response. The field is also
 * useless here: a take-home reader has exactly one Visit, and every route that accepts a
 * visit id requires a credential this reader does not have. Same split, and the same reason,
 * as `JoinCode`/`JoinCodeInput` and `ArtifactId`/`TakeHomeArtifactId`.
 * 
 * @export
 * @interface TakeHomeArtifactSummary
 */
export interface TakeHomeArtifactSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    kind: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    activityKey?: string | null;
    /**
     * 
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the TakeHomeArtifactSummary interface.
 */
export function instanceOfTakeHomeArtifactSummary(value: object): value is TakeHomeArtifactSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    return true;
}

export function TakeHomeArtifactSummaryFromJSON(json: any): TakeHomeArtifactSummary {
    return TakeHomeArtifactSummaryFromJSONTyped(json, false);
}

export function TakeHomeArtifactSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TakeHomeArtifactSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'kind': json['kind'],
        'title': json['title'],
        'activityKey': json['activity_key'] === undefined ? undefined : json['activity_key'] === null ? null : json['activity_key'],
        'createdAt': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
    };
}

export function TakeHomeArtifactSummaryToJSON(json: any): TakeHomeArtifactSummary {
    return TakeHomeArtifactSummaryToJSONTyped(json, false);
}

export function TakeHomeArtifactSummaryToJSONTyped(value?: TakeHomeArtifactSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'kind': value['kind'],
        'title': value['title'],
        'activity_key': value['activityKey'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
    };
}

